/**
 * Filters pickup locations by program ID.
 *
 * Used in address modals to show only the pickup locations that are valid
 * for a specific order's program. Each pickup location has a list of program IDs
 * it supports (`locationProgramIds`).
 *
 * @param locations - All available pickup locations
 * @param programId - The program ID to filter by (from an order)
 * @returns Filtered array of locations, or all locations if programId is undefined
 *
 * @example
 * ```typescript
 * const allLocations = [
 *   { name: "Location A", locationProgramIds: [1, 2] },
 *   { name: "Location B", locationProgramIds: [2, 3] }
 * ];
 * const filtered = filterLocationsByProgramId(allLocations, 2);
 * // Returns both locations since both support program 2
 * ```
 */
export const filterLocationsByProgramId = (locations, programId) => {
    // If no programId provided, return all locations
    if (!programId) {
        return locations;
    }
    // Filter to only locations that support this program
    return locations.filter((location) => { var _a; return (_a = location === null || location === void 0 ? void 0 : location.locationProgramIds) === null || _a === void 0 ? void 0 : _a.includes(programId); });
};
